import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip as AntTooltip } from 'antd';

const Tooltip = (props) => {
  const style = {
    whiteSpace: 'no-wrap',
    fontSize: '0.9rem',
    color: '#0e306d',
    minHeight: '0',
  };

  return (
    <AntTooltip
      title={props.tooltip}
      placement={props.right ? 'right' : 'bottom'}
      styles={{ body: style }}
      classNames={{ root: props.className }}
      color={'#fff0ca'}
      // color={'#feb81c'}
      {...(props.maxWidth && { overlayStyle: { maxWidth: props.maxWidth } })}
    >
      {props.children}
    </AntTooltip>
  );
};

Tooltip.propTypes = {
  tooltip: PropTypes.string,
  right: PropTypes.bool,
  as: PropTypes.any,
};

export default Tooltip;
